import React from "react";

function RefundRulesAndClaimsKn() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">
          ಕ್ಲೈಮ್‌ಗಳಿಗೆ ಮರುಪಾವತಿ ನಿಯಮಗಳು ಮತ್ತು ವಿಧಾನ
        </h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            ಪ್ರಯಾಣಿಕರಿಂದ ಟಿಕೆಟ್ ರದ್ದತಿ:
          </h5>
        </div>
        <div className="letters-color-section-table-section">
          <div className="heading-main">
            ಪ್ರಯಾಣಿಕರು ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ನಲ್ಲಿ ಪ್ರಯಾಣಿಸದಿದ್ದರೆ, ಕೆಳಗೆ
            ನಿರ್ದಿಷ್ಟಪಡಿಸಿದ ಷರತ್ತುಗಳ ಪ್ರಕಾರ ಅವರು ಟಿಕೆಟ್ ಅನ್ನು
            ರದ್ದುಗೊಳಿಸಬೇಕಾಗುತ್ತದೆ;
            <div className="heading">
              <ol>
                <li>
                  KSRTC/ಅಧಿಕೃತ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ಗಳನ್ನು
                  ಯಾವುದೇ ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಒರಿಜಿನಲ್ ಕೌಂಟರ್ ಟಿಕೆಟ್‌ಗಳ ಉತ್ಪಾದನೆಯ ಮೇಲೆ
                  ರದ್ದುಗೊಳಿಸಬಹುದು.
                </li>
                <li>
                  ಆನ್‌ಲೈನ್ / ಮೊಬೈಲ್ ಬುಕಿಂಗ್ ಮೂಲಕ ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ಗಳನ್ನು
                  ಆನ್‌ಲೈನ್ / ಮೊಬೈಲ್ ಮೂಲಕ ಮಾತ್ರ ರದ್ದುಗೊಳಿಸಬೇಕು. ರದ್ದತಿಗಳಿಗೆ
                  ಸಂಬಂಧಿಸಿದಂತೆ, ಮರುಪಾವತಿಗಳನ್ನು ಸಂಬಂಧಪಟ್ಟ ಕ್ರೆಡಿಟ್
                  ಕಾರ್ಡ್/ಆನ್‌ಲೈನ್ ಬ್ಯಾಂಕಿಂಗ್ ಖಾತೆಗೆ ಮಾತ್ರ ಮಾಡಲಾಗುತ್ತದೆ.
                </li>
                <li>
                  <span className="span-class"> ಅತಿಥಿ ಬಳಕೆದಾರ: </span> ಅತಿಥಿ
                  ಬಳಕೆದಾರರಾಗಿ ಬುಕ್ ಮಾಡಿದ ಆನ್‌ಲೈನ್ ಟಿಕೆಟ್‌ಗಳನ್ನು www.ksrtc.in
                  (http://www.ksrtc.in/AWATAROnline/preETCancel) ನಲ್ಲಿ ಬಲ
                  ಮೂಲೆಯಲ್ಲಿ ಕಾಣಿಸುವ “ಅತಿಥಿ ಬಳಕೆದಾರರ ಟಿಕೆಟ್” ಮೂಲಕ
                  ರದ್ದುಗೊಳಿಸಬೇಕಾಗುತ್ತದೆ. .do?hiddenAction=GuestUser).
                </li>
                <li>
                  <span className="span-class"> ನೋಂದಾಯಿತ ಬಳಕೆದಾರರು:</span>{" "}
                  ನೋಂದಾಯಿತ ಬಳಕೆದಾರರು ಬುಕ್ ಮಾಡಿದ ಆನ್‌ಲೈನ್ ಟಿಕೆಟ್‌ಗಳನ್ನು ಅದೇ
                  ಬಳಕೆದಾರರು ತಮ್ಮ ಖಾತೆಗೆ ಲಾಗ್ ಇನ್ ಮಾಡುವ ಮೂಲಕ
                  ರದ್ದುಗೊಳಿಸಬೇಕಾಗುತ್ತದೆ.
                </li>
                <li>
                  <span className="span-class"> ಕೌಂಟರ್ ಇ-ಟಿಕೆಟ್: </span>ಕೌಂಟರ್
                  ಇ-ಟಿಕೆಟ್ ರದ್ದುಗೊಳಿಸಲು ಟಿಕೆಟ್ ಪ್ರಿಂಟ್ ಔಟ್ ಜೊತೆಗೆ ಗುರುತಿನ
                  ಪುರಾವೆಯನ್ನು ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಕಡ್ಡಾಯವಾಗಿ ತೋರಿಸಬೇಕು.
                </li>
                <li>
                  ಮಾಸ್ಟರ್ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳ ಮೂಲಕ (ಬೆಂಗಳೂರು-ಒಂದು) ಬುಕ್ ಮಾಡಿದ
                  ಟಿಕೆಟ್‌ಗಳನ್ನು ಆಯಾ ಮಾಸ್ಟರ್ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳು /
                  ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ ಕೌಂಟರ್‌ಗಳ ಮೂಲಕ ಮಾತ್ರ ರದ್ದುಗೊಳಿಸಬೇಕು.
                </li>
                <li>
                  ಮಾಸ್ಟರ್ ಫ್ರಾಂಚೈಸಿ ವೆಬ್‌ಸೈಟ್‌ಗಳ ಮೂಲಕ (ಮೊಬೈಲ್ ಒನ್ ಮತ್ತು
                  ಬಸ್‌ಇಂಡಿಯಾ) ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ಗಳನ್ನು ಆಯಾ ಮಾಸ್ಟರ್ ಫ್ರಾಂಚೈಸಿ
                  ವೆಬ್‌ಸೈಟ್‌ಗಳ ಮೂಲಕ ಮಾತ್ರ ರದ್ದುಗೊಳಿಸಬೇಕು.
                </li>
                <li>
                  <span className="span-class"> ಕೌಂಟರ್ ಕೆಲಸದ ಸಮಯ: </span> 0700
                  ರಿಂದ 2200 ಗಂಟೆಗಳು. ಕೌಂಟರ್ ಕೆಲಸದ ಸಮಯವು ಸ್ಥಳದಿಂದ ಸ್ಥಳಕ್ಕೆ
                  ಬದಲಾಗಬಹುದು.
                </li>
                <li>
                  ಆನ್‌ಲೈನ್/ಮೊಬೈಲ್ ಬುಕಿಂಗ್ ಮತ್ತು ರದ್ದತಿ 2400 ಗಂಟೆಗಳಲ್ಲಿ ಲಭ್ಯವಿದೆ.
                </li>
                <li>
                  ಟಿಕೆಟ್‌ಗಳನ್ನು ಬುಕ್ ಮಾಡಿದ ಸೇವೆಗಾಗಿ ಟ್ರಿಪ್‌ಶೀಟ್ ರಚಿಸುವವರೆಗೆ ಅಥವಾ
                  ನಿರ್ಗಮನಕ್ಕೆ ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು, ಯಾವುದು ಮೊದಲು, ಕೆಳಗೆ ವಿವರಿಸಿದಂತೆ
                  ಟಿಕೆಟ್‌ಗಳ ರದ್ದತಿಯನ್ನು ಅನುಮತಿಸಲಾಗುತ್ತದೆ;
                </li>
              </ol>
            </div>
            <div className="heading">
              <table>
                <tr>
                  <th>ನಲ್ಲಿ ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಲಾಗಿದೆ</th>
                  <th>ರದ್ದತಿಯನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ</th>
                  <th>ಟಿಪ್ಪಣಿಗಳು</th>
                </tr>
                <tr>
                  <td>KSRTC ಕೌಂಟರ್‌ಗಳು</td>
                  <td>ಹೊರಡುವ ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು.</td>
                  <td>ನಂತರ ಮರುಪಾವತಿ ಇಲ್ಲ.</td>
                </tr>
                <tr>
                  <td> ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳು</td>
                  <td>
                    ಕೌಂಟರ್‌ಗಳ ಲಭ್ಯತೆಗೆ ಒಳಪಟ್ಟು ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಿದ ಸೇವೆಗಾಗಿ
                    ಟ್ರಿಪ್‌ಶೀಟ್ ರಚಿಸುವವರೆಗೆ ಅಥವಾ ನಿರ್ಗಮನಕ್ಕೆ ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು,
                    ಯಾವುದು ಮುಂಚೆಯೋ ಅದು .
                  </td>
                  <td>ನಂತರ ಮರುಪಾವತಿ ಇಲ್ಲ.</td>
                </tr>
                <tr>
                  <td>ಎಟಿಕೆಟಿಂಗ್ ಮತ್ತು ಮೊಬೈಲ್ ಬುಕಿಂಗ್</td>
                  <td>
                    ಕೌಂಟರ್‌ಗಳ ಲಭ್ಯತೆಗೆ ಒಳಪಟ್ಟು ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಿದ ಸೇವೆಗಾಗಿ
                    ಟ್ರಿಪ್‌ಶೀಟ್ ರಚಿಸುವವರೆಗೆ ಅಥವಾ ನಿರ್ಗಮನಕ್ಕೆ ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು,
                    ಯಾವುದು ಮೊದಲು.
                  </td>
                  <td>ರದ್ದತಿ ವಿನಂತಿಯನ್ನು ಅದರ ನಂತರ ನೋಂದಾಯಿಸಲಾಗುತ್ತದೆ.</td>
                </tr>
                <tr>
                  <td>ಮಾಸ್ಟರ್ ಫ್ರ್ಯಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳು ಮತ್ತು ವೆಬ್‌ಸೈಟ್‌ಗಳು</td>
                  <td>
                    ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಿದ ಸೇವೆಗಾಗಿ ಟ್ರಿಪ್‌ಶೀಟ್ ರಚಿಸುವವರೆಗೆ ಅಥವಾ
                    ನಿರ್ಗಮನಕ್ಕೆ ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು, ಯಾವುದು ಮೊದಲು.
                  </td>
                  <td>ನಂತರ ಮರುಪಾವತಿ ಇಲ್ಲ</td>
                </tr>
              </table>
            </div>
          </div>

          <div className="heading-main">
            ರದ್ದತಿ ಶುಲ್ಕ ಸ್ಲ್ಯಾಬ್‌ಗಳು
            <div className="heading">
              <table>
                <tr>
                  <th> ರದ್ದತಿ ಶುಲ್ಕ</th>
                  <th>ಅವಧಿ ರದ್ದತಿ ಸಮಯ</th>
                  <th>ಟಿಪ್ಪಣಿಗಳು</th>
                </tr>
                <tr>
                  <td>ಮೂಲ ದರದ 10%</td>
                  <td>ನಿರ್ಗಮನ ಸಮಯಕ್ಕಿಂತ 72 ಗಂಟೆಗಳ ಮೊದಲು</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>ಮೂಲ ದರದ 25%</td>
                  <td>ನಿರ್ಗಮನದ ಸಮಯಕ್ಕೆ 72 ಗಂಟೆಗಳ ಮೊದಲು ಮತ್ತು 24 ಗಂಟೆಗಳವರೆಗೆ</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>ಮೂಲ ದರದ 50%</td>
                  <td>ಹೊರಡುವ ಸಮಯಕ್ಕೆ 24 ಗಂಟೆಗಳ ಮತ್ತು ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td> ಮರುಪಾವತಿ ಇಲ್ಲ</td>
                  <td>
                    ಹೊರಡುವ ಸಮಯಕ್ಕೆ ಎರಡು ಗಂಟೆಗಳಿಗಿಂತ ಕಡಿಮೆ ಸಮಯ ಮತ್ತು ನಿರ್ಗಮನದ
                    ಸಮಯದಲ್ಲಿ/ನಂತರ
                  </td>
                  <td>ಮರುಪಾವತಿ ಇಲ್ಲ.</td>
                </tr>
              </table>
            </div>
            <div className="heading">
              ರದ್ದತಿ ಶುಲ್ಕವನ್ನು ಪ್ರಯಾಣಿಕರ ಕಾಯ್ದಿರಿಸುವಿಕೆಯ ಮೊತ್ತದಿಂದ
              ಕಡಿತಗೊಳಿಸಲಾಗುತ್ತದೆ.
            </div>
            <div className="heading">
              ರದ್ದತಿ ಸ್ಲ್ಯಾಬ್‌ಗಳು (% ಶುಲ್ಕ ಮರುಪಾವತಿ) ರದ್ದತಿಯ ಸಮಯ ಮತ್ತು ಬೋರ್ಡಿಂಗ್
              ಸ್ಥಳದಲ್ಲಿ ಸೇವೆಯ ನಿರ್ಗಮನ ಸಮಯವನ್ನು ಆಧರಿಸಿದೆ.
            </div>
            <div className="heading">
              ಟಿಕೆಟ್‌ಗಳ ರದ್ದತಿಗಾಗಿ, ರದ್ದತಿ ಶುಲ್ಕವನ್ನು ಅನ್ವಯವಾಗುವ ಪ್ರಯಾಣ ದರದ ಮೇಲೆ
              ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ.
            </div>
            <div className="heading">
              ರಿಯಾಯಿತಿಗಳೊಂದಿಗೆ ಟಿಕೆಟ್‌ಗಳ ರದ್ದತಿ ಮೇಲಿನ ಕಾರ್ಯವಿಧಾನದ ಪ್ರಕಾರ
              ಇರುತ್ತದೆ. ಆದಾಗ್ಯೂ, ರದ್ದತಿ ಶುಲ್ಕಗಳು ಪ್ರಯಾಣಿಕರಿಂದ ಪಾವತಿಸಬೇಕಾದ ಮೂಲ
              ದರದ ಮೇಲೆ ಕೆಲಸ ಮಾಡಲಾಗುವುದು ಮತ್ತು ಮರುಪಾವತಿ ಮೊತ್ತವು ನಿಜವಾದ ಶುಲ್ಕವನ್ನು
              ಕಡಿಮೆ ರದ್ದುಗೊಳಿಸುವ ಶುಲ್ಕವನ್ನು ಸಂಗ್ರಹಿಸುತ್ತದೆ.
            </div>
            <div className="heading">
              ರಿಸರ್ವೇಷನ್ ಶುಲ್ಕವನ್ನು ಮರುಪಾವತಿಸಲಾಗುವುದಿಲ್ಲ.
            </div>
            <div className="heading">
              ಸೇತುವೆ ಶುಲ್ಕ, ಬಳಕೆದಾರರ ಶುಲ್ಕ, ಟೋಲ್ ಶುಲ್ಕ, ಪ್ರವೇಶ ಶುಲ್ಕ
              ಇತ್ಯಾದಿಗಳನ್ನು ಸಂಪೂರ್ಣವಾಗಿ ಮರುಪಾವತಿಸಲಾಗುವುದು.
            </div>
            <div className="heading">
              ಮೇಲಿನ ಷರತ್ತುಗಳು ಭಾಗಶಃ ರದ್ದತಿಗೂ ಅನ್ವಯಿಸುತ್ತವೆ.
            </div>
            <div className="heading">
              ಭಾಗಶಃ ರದ್ದತಿಯ ಸಂದರ್ಭದಲ್ಲಿ, ಸೀಟ್ ನಂ. ಪ್ರಯಾಣಿಸದ ಪ್ರಯಾಣಿಕರನ್ನು
              ರದ್ದುಗೊಳಿಸಬೇಕು.
            </div>
            <div className="heading">
              ಭಾಗಶಃ ರದ್ದತಿಯ ಸಂದರ್ಭದಲ್ಲಿ, ರದ್ದತಿಯ ನಂತರದ ಪ್ರಯಾಣಿಕರ ಸಂಖ್ಯೆ
              ನಾಲ್ಕಕ್ಕಿಂತ ಕಡಿಮೆಯಾದರೆ, ಎಲ್ಲಾ ಆಸನಗಳಿಗೆ ಗುಂಪು ರಿಯಾಯಿತಿಯನ್ನು
              ಹಿಂಪಡೆಯಲಾಗುತ್ತದೆ.
            </div>
            <div className="heading">
              ಮುಂದಿನ ಪ್ರಯಾಣದ ಟಿಕೆಟ್ ಅನ್ನು ರದ್ದುಗೊಳಿಸಿದರೆ, ಹಿಂದಿರುಗುವ ಪ್ರಯಾಣದ
              ಟಿಕೆಟ್ ಮೇಲಿನ ರಿಯಾಯಿತಿಯನ್ನು ಹಿಂಪಡೆಯಲಾಗುತ್ತದೆ.
            </div>
            <div className="heading">
              ಪ್ರಯಾಣಿಕರು ಸೇವೆಯ ಮೂಲ ಸ್ಥಳಗಳಲ್ಲಿ ಕೌಂಟರ್‌ಗಳ ಲಭ್ಯತೆ ಮತ್ತು ಟಿಕೆಟ್‌ಗಳ
              ರದ್ದತಿಗೆ ಸಾಕಷ್ಟು ಸಮಯವನ್ನು ಪಡೆಯುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು
              ಟ್ರಿಪ್‌ಶೀಟ್‌ಗಳನ್ನು ಉತ್ಪಾದಿಸುವ ಸಮಯದ ಬಗ್ಗೆ ಮಾಹಿತಿಯನ್ನು ಇಟ್ಟುಕೊಳ್ಳಲು
              ವಿನಂತಿಸಲಾಗಿದೆ.
            </div>
            <div className="heading">
              <span className="span-class">
                ಪ್ರಯಾಣಿಸಸದಿದ್ದರೆ ಅಥವಾ ಟಿಕೆಟ್ ರದ್ದುಗೊಳಿಸದಿದ್ದರೆ ಯಾವುದೇ
                ಮರುಪಾವತಿಯನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.
              </span>
            </div>
            <div className="heading">
              ಬಳಕೆದಾರರಿಂದ ರದ್ದುಗೊಳಿಸಲಾಗದ ಆನ್‌ಲೈನ್ ಟಿಕೆಟ್‌ಗಳಿಗಾಗಿ, ಬಳಕೆದಾರರು
              awatar@ksrtc.org ಗೆ ಇಮೇಲ್ ಕಳುಹಿಸಬೇಕಾಗುತ್ತದೆ. ಮರುಪಾವತಿ
              ಸ್ಲ್ಯಾಬ್‌ಗಳನ್ನು ನಿರ್ಧರಿಸಲು ಇಮೇಲ್‌ನ ದಿನಾಂಕ ಮತ್ತು ಸಮಯವು
              ಆಧಾರವಾಗಿರುತ್ತದೆ. AWATAR ಸೆಲ್ ನೀಡಿದ ಪ್ರತಿಕ್ರಿಯೆ/ಮಾರ್ಗದರ್ಶನವನ್ನು
              ಪರಿಶೀಲಿಸಲು ಬಳಕೆದಾರರನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ.
            </div>
            <div className="heading">
              ಮುಂಗಡ ಬುಕಿಂಗ್/ರದ್ದತಿಯಲ್ಲಿ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ, ಪ್ರಯಾಣಿಕರು ಕಾಲ್
              ಸೆಂಟರ್, 080-26252625 (24 ಗಂಟೆಗಳು) ಅಥವಾ ಅವತಾರ್ ಸೆಲ್ 7760990034,
              7760990035 (0700 ರಿಂದ 2200 ಗಂಟೆಗಳು) ಸಂಪರ್ಕಿಸಬಹುದು.
            </div>
          </div>

          <div className="heading-main">
            ಮರುಪಾವತಿ ಹಕ್ಕುಗಳು ಮತ್ತು ಕಾರ್ಯವಿಧಾನ
            <div className="heading">
              <div className="heading">
                ಎಲ್ಲಾ ಮರುಪಾವತಿ ಹಕ್ಕುಗಳನ್ನು{" "}
                <a
                  className="link-href"
                  href="awatar@ksrtc.org"
                  target="_blank"
                >
                  awatar@ksrtc.org
                </a>{" "}
                ಗೆ ಇಮೇಲ್ ಮೂಲಕ ಅಥವಾ 9449596666 ಕಾಲ್ ಸೆಂಟರ್ ಗೆ ಸಲ್ಲಿಸಬೇಕು.
              </div>
              <div className="heading">
                ಮರುಪಾವತಿ ಹಕ್ಕುಗಳನ್ನು ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣದ ದಿನಾಂಕದಿಂದ 30 ದಿನಗಳಲ್ಲಿ
                ಸಲ್ಲಿಸಬೇಕು. 30 ದಿನಗಳ ನಂತರ ಸ್ವೀಕರಿಸಿದ ಕ್ಲೈಮ್ಸ್
                ಪರಿಗಣಿಸಲಾಗುವುದಿಲ್ಲ.
              </div>
              <div className="heading">
                ಎಲ್ಲಾ ಮರುಪಾವತಿ ಹಕ್ಕುಗಳಿಗಾಗಿ, ಪ್ರಯಾಣಿಕರು PNR ನಂ. ಅಥವಾ ETM
                ಟಿಕೆಟ್‌ನ ನಕಲು ಮತ್ತು ಅವರ ಕುಂದುಕೊರತೆ / ಮರುಪಾವತಿ ಕ್ಲೈಮ್‌ಗೆ
                ಕಾರಣಗಳನ್ನು ವಿವರಿಸಿ. ಕ್ಲೈಮ್ ಅನ್ನು ನಿರ್ಧರಿಸಲು ಅಗತ್ಯವಿರುವಲ್ಲಿ
                ಹೆಚ್ಚುವರಿ ವಿವರಗಳು/ದಾಖಲೆಗಳನ್ನು ಸಲ್ಲಿಸಬೇಕಾಗುತ್ತದೆ.
              </div>
              <div className="heading">
                ಮರುಪಾವತಿಯನ್ನು ನಿರ್ಧರಿಸುವ ಮೊದಲು ಎಲ್ಲಾ ಮರುಪಾವತಿ ಹಕ್ಕುಗಳನ್ನು
                ಕಾರ್ಯಾಚರಣೆ ಘಟಕಗಳ ಮೂಲಕ ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ. ವಿವರವಾದ ತನಿಖೆಗಳ
                ಅಗತ್ಯವಿರುವ ಕ್ಲೈಮ್‌ಗಳನ್ನು ಹೊರತುಪಡಿಸಿ ಕ್ಲೈಮ್ ಅನ್ನು ಸ್ವೀಕರಿಸಿದ
                ದಿನಾಂಕದಿಂದ 15 ದಿನಗಳಲ್ಲಿ ಮರುಪಾವತಿ ಪ್ರಕ್ರಿಯೆಯು ಪೂರ್ಣಗೊಳ್ಳುತ್ತದೆ.
              </div>
            </div>
            <div className="heading">
              ಕೆಳಗೆ ತಿಳಿಸಲಾದ ಕಾರಣಗಳಿಗಾಗಿ ಪ್ರಯಾಣಿಕರು ದರದ ಮರುಪಾವತಿಯನ್ನು ಪಡೆಯಬಹುದು;
              <table>
                <tr>
                  <th style={{ width: "50%;" }}>
                    ಮರುಪಾವತಿಯನ್ನು ಕ್ಲೈಮ್ ಮಾಡಲು ಕಾರಣRefund
                  </th>
                  <th style={{ width: "50%;" }}> ಮರುಪಾವತಿಗೆ ವಿಧಾನ</th>
                </tr>
                <tr>
                  <td>
                    ಸೇವೆಯನ್ನು KSRTC ರದ್ದುಗೊಳಿಸಿದೆ ಮತ್ತು ಎಸ್‌ಎಂಎಸ್/ಇಮೇಲ್ ಮೂಲಕ
                    ತಿಳಿಸಲಾಗಿದೆ.
                  </td>
                  <td>
                    ಆನ್‌ಲೈನ್ / ಮೊಬೈಲ್ ಟಿಕೆಟ್‌ಗಳಿಗಾಗಿ, AWATAR ಸಾಫ್ಟ್‌ವೇರ್ ಮೂಲಕ
                    ಮರುಪಾವತಿಯನ್ನು ಪ್ರಾರಂಭಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಮರುಪಾವತಿಯನ್ನು ಏಳು
                    ದಿನಗಳಲ್ಲಿ ಪ್ರಯಾಣಿಕರ ಖಾತೆಗೆ ಜಮಾ ಮಾಡಲಾಗುತ್ತದೆ. ರದ್ದಾದ ದಿನಾಂಕದ
                    ಏಳು ದಿನಗಳೊಳಗೆ ಮರುಪಾವತಿಯನ್ನು ಸ್ವೀಕರಿಸದಿದ್ದರೆ ಪ್ರಯಾಣಿಕರು KSRTC
                    ಅನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು. ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ಗಳಿಗೆ,
                    ಪ್ರಯಾಣಿಕರು ಮೂಲ ಟಿಕೆಟ್‌ಗಳನ್ನು ತಯಾರಿಸಬೇಕು ಮತ್ತು KSRTC /
                    ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳಿಂದ ಮರುಪಾವತಿಯನ್ನು ಪಡೆಯಬೇಕು. ನಿರ್ಗಮನ ಸಮಯದ
                    ನಂತರ ಅಂತಹ ಮರುಪಾವತಿಗಳನ್ನು KSRTC ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಮಾತ್ರ
                    ಅನುಮತಿಸಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ಎರಡು ಗಂಟೆಗಳಿಗಿಂತ ಹೆಚ್ಚು ತಡವಾಗಿ ಹೊರಡುವ ಬಸ್ ಅಥವಾ ಸೇವೆಯನ್ನು
                    ನಿರ್ವಹಿಸಲಾಗಿಲ್ಲ.
                  </td>
                  <td>
                    ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣಿಸದಿದ್ದರೆ, ಸಂಪೂರ್ಣ ಮರುಪಾವತಿಯನ್ನು
                    ನೀಡಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ರಿಸರ್ವೇಷನ್ ಸಾಫ್ಟ್‌ವೇರ್ ದೋಷದಿಂದಾಗಿ ಟ್ರಿಪ್-ಶೀಟ್‌ನಲ್ಲಿ ಟಿಕೆಟ್
                    ವಿವರಗಳು ಕಾಣೆಯಾಗಿದೆ.
                  </td>
                  <td>
                    ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣಿಸದಿದ್ದರೆ, ಸಂಪೂರ್ಣ ಮರುಪಾವತಿಯನ್ನು
                    ನೀಡಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    Bus did not pick up the passenger at the specified pickup
                    point
                  </td>
                  <td>
                    ಈ ಕ್ಲೈಮ್‌ಗೆ KSRTC ಜವಾಬ್ದಾರರಾಗಿದ್ದರೆ ಸಂಪೂರ್ಣ ಶುಲ್ಕವನ್ನು
                    ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ನಿಗದಿತ ಪಿಕಪ್ ಪಾಯಿಂಟ್‌ನಲ್ಲಿ ಬಸ್ ಪ್ರಯಾಣಿಕರನ್ನು ಹತ್ತಲಿಲ್ಲ ಮುಂದೆ
                    ಮತ್ತು ಹಿಂದಿರುಗುವ ಪ್ರಯಾಣದ ಟಿಕೆಟ್‌ಗಳನ್ನು ಬುಕ್ ಮಾಡಿದ
                    ಪ್ರಯಾಣಿಕರಿಗೆ ಮುಂದಿನ ಪ್ರಯಾಣದ ಸೇವೆಯ ರದ್ದತಿ/ತಡವಾಗಿ ನಿರ್ಗಮನ.
                    ರಿಟರ್ನ್ ಜರ್ನಿ ಟಿಕೆಟ್‌ಗಾಗಿ ಮರುಪಾವತಿ ಹಕ್ಕು ಇರುತ್ತದೆ.
                  </td>
                  <td>
                    ಮರುಪಾವತಿ ಕ್ಲೈಮ್ ಅನ್ನು ಆಧರಿಸಿ ಅರ್ಹ ಮೊತ್ತವನ್ನು
                    ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ನಿಗದಿತ ಉನ್ನತ ದರ್ಜೆಯ ಸೇವೆಯ ಬದಲಿಗೆ ಕಡಿಮೆ ದರ್ಜೆಯ ಸೇವೆಯಿಂದ
                    ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣಿಸುತ್ತಾರೆ.
                  </td>
                  <td>ಪ್ರಯಾಣ ದರದಲ್ಲಿನ ವ್ಯತ್ಯಾಸವನ್ನು ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ.</td>
                </tr>
                <tr>
                  <td>
                    ಸ್ಥಗಿತ/ಅಪಘಾತ/ಇತರ ಯಾವುದೇ ಕಾರಣಗಳಿಂದ ಪೂರ್ಣ ದೂರದವರೆಗೆ ಸೇವೆಯನ್ನು
                    ನಿರ್ವಹಿಸದ ಕಾರಣ ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣದ ಭಾಗವಾಗಿ ಪ್ರಯಾಣಿಸಿದ್ದಾರೆ.
                  </td>
                  <td>ಪ್ರಯಾಣ ದರದಲ್ಲಿನ ವ್ಯತ್ಯಾಸವನ್ನು ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ.</td>
                </tr>
                <tr>
                  <td>
                    ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ಎಸಿ ಕೆಲಸ ಮಾಡದ ಕಾರಣ ಮರುಪಾವತಿ ಕ್ಲೈಮ್‌ಗಳು
                  </td>
                  <td>
                    ಪ್ರಯಾಣದ AC ಕಾರ್ಯನಿರ್ವಹಿಸದ ಭಾಗಕ್ಕೆ ಮೂಲ ದರದ 25%
                    ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ರದ್ದತಿಯ ಸಮಯದಲ್ಲಿ ಕಡಿಮೆ ಮರುಪಾವತಿ, ಮೀಸಲಾತಿ ಟಿಕೆಟ್‌ನಲ್ಲಿ
                    ವಿಧಿಸಲಾದ ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ (ರಿಯಾಯಿತಿ / ರಿಯಾಯಿತಿ ನೀಡಲಾಗಿಲ್ಲ,
                    ದರವನ್ನು ಕಡಿಮೆ ಮಾಡಲಾಗಿದೆ) ಇತ್ಯಾದಿಗಳಂತಹ ಮೀಸಲಾತಿ ಸಾಫ್ಟ್‌ವೇರ್
                    ದೋಷಗಳಿಂದಾಗಿ ವ್ಯತ್ಯಾಸ ಮೊತ್ತದ ಕ್ಲೈಮ್‌ಗಳು.
                  </td>
                  <td>
                    ಮರುಪಾವತಿ ಕ್ಲೈಮ್ ಅನ್ನು ಆಧರಿಸಿ ಅರ್ಹ ಮೊತ್ತವನ್ನು
                    ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ಗುರುತಿನ ಪುರಾವೆಗಳನ್ನು ನೀಡದ ಕಾರಣ ಪ್ರಯಾಣಿಕರಿಗೆ
                    ಆನ್‌ಲೈನ್ / ಮೊಬೈಲ್ ಟಿಕೆಟ್ ಬಳಸಿ ಪ್ರಯಾಣವನ್ನು ನಿರ್ವಹಿಸಲು
                    ಸಾಧ್ಯವಾಗುವುದಿಲ್ಲ
                  </td>
                  <td>
                    ETM ಟಿಕೆಟ್ ಖರೀದಿಸುವ ಮೂಲಕ ಪ್ರಯಾಣಿಕರು ಅದೇ ಸೇವೆಯಲ್ಲಿ
                    ಪ್ರಯಾಣಿಸಿರಬೇಕು ಎಂಬ ಷರತ್ತಿಗೆ ಒಳಪಟ್ಟು ಮೂಲ ದರದ 50% ಅನ್ನು
                    ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ. ಇಟಿಎಂ ಟಿಕೆಟ್‌ನ ಪ್ರತಿ ಕಡ್ಡಾಯವಾಗಿದೆ.
                    ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣಿಸದಿದ್ದರೆ ಮರುಪಾವತಿಯನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.
                  </td>
                </tr>
                <tr>
                  <td>
                    ಸಾಫ್ಟ್‌ವೇರ್ ದೋಷ, ಟ್ರಿಪ್‌ಶೀಟ್ ಅನ್ನು ಮೊದಲೇ ಮುದ್ರಿಸಿರುವುದು,
                    ಪ್ರಯಾಣಿಕರು ಹೊರಡುವ ಸ್ಥಳದಲ್ಲಿ ಕಾಯ್ದಿರಿಸುವಿಕೆ ಕೌಂಟರ್
                    ಲಭ್ಯವಿಲ್ಲದಿರುವುದು / ಕೆಲಸ ಮಾಡದಿರುವ ಕಾರಣ ಪ್ರಯಾಣಿಕರಿಗೆ ಟಿಕೆಟ್
                    ರದ್ದುಗೊಳಿಸಲು ಸಾಧ್ಯವಾಗದಿದ್ದಾಗ ಮರುಪಾವತಿಗಾಗಿ ಕ್ಲೈಮ್ ಮಾಡಿ.
                  </td>
                  <td>
                    <a
                      className="link-href"
                      href="awatar@ksrtc.org"
                      target="_blank"
                    >
                      awatar@ksrtc.org.
                    </a>{" "}
                    ಗೆ ಇಮೇಲ್ ಮಾಡಿದ ದಿನಾಂಕ ಮತ್ತು ಸಮಯದ ಆಧಾರದ ಮೇಲೆ ಅರ್ಹ ಮೊತ್ತವನ್ನು
                    ಮರುಪಾವತಿಸಲಾಗುತ್ತದೆ. AWATAR ಸೆಲ್ ನೀಡಿದ
                    ಪ್ರತಿಕ್ರಿಯೆ/ಮಾರ್ಗದರ್ಶನವನ್ನು ಪರಿಶೀಲಿಸಲು ಪ್ರಯಾಣಿಕರನ್ನು
                    ವಿನಂತಿಸಲಾಗಿದೆ.
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div className="heading-main">
            ಮರುಪಾವತಿ ವಿಧಾನ:
            <div className="heading">
              <div className="heading">
                ಆನ್‌ಲೈನ್/ಮೊಬೈಲ್ ಟಿಕೆಟ್‌ಗಳಿಗೆ, ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಲು ಬಳಸಲಾದ ಪ್ರಯಾಣಿಕರ
                ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್/ನೆಟ್‌ಬ್ಯಾಂಕಿಂಗ್ ಖಾತೆಗೆ ಅನ್ವಯವಾಗುವ ಮರುಪಾವತಿಯನ್ನು
                ಕ್ರೆಡಿಟ್ ಮಾಡಲಾಗುತ್ತದೆ.
              </div>
              <div className="heading">
                ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ಗಳಿಗೆ, ಪ್ರಯಾಣಿಕರು ಮೂಲ
                ಟಿಕೆಟ್‌ಗಳನ್ನು ತೋರಿಸಬೇಕು ಮತ್ತು KSRTC / ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳಿಂದ
                ಅನ್ವಯವಾಗುವ ಮರುಪಾವತಿಯನ್ನು ಸಂಗ್ರಹಿಸಬೇಕು.ನಿರ್ಗಮನ ಸಮಯದ ನಂತರ ಅಂತಹ
                ಮರುಪಾವತಿಗಳನ್ನು KSRTC ಕೌಂಟರ್‌ಗಳಲ್ಲಿ ಮಾತ್ರ ಅನುಮತಿಸಲಾಗುತ್ತದೆ.
              </div>
              <div className="heading">
                ಮಾಸ್ಟರ್ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳ ಮೂಲಕ (ಬೆಂಗಳೂರು-ಒಂದು) ಬುಕ್ ಮಾಡಿದ
                ಟಿಕೆಟ್‌ಗಳಿಗೆ, ಪ್ರಯಾಣಿಕರು ಗುರುತಿನ ಪುರಾವೆಯೊಂದಿಗೆ ಮೂಲ ಟಿಕೆಟ್ ಅನ್ನು
                ಹಾಜರುಪಡಿಸಬೇಕು ಮತ್ತು ಅನ್ವಯವಾಗುವ ಮರುಪಾವತಿಯನ್ನು KSRTC ಕೌಂಟರ್‌ಗಳಿಂದ
                ಮಾತ್ರ ಸಂಗ್ರಹಿಸಬೇಕು.
              </div>
              <div className="heading">
                ಮಾಸ್ಟರ್ ಫ್ರಾಂಚೈಸಿ ವೆಬ್‌ಸೈಟ್‌ಗಳ ಮೂಲಕ ಬುಕ್ ಮಾಡಿದ ಟಿಕೆಟ್‌ಗಳಿಗೆ
                (ಮೊಬೈಲ್ ಒನ್ ಮತ್ತು ಬಸ್‌ಇಂಡಿಯಾ), ಆಯಾ ಮಾಸ್ಟರ್ ಫ್ರ್ಯಾಂಚೈಸಿ
                ವೆಬ್‌ಸೈಟ್‌ಗಳ ಮೂಲಕ ಮಾತ್ರ ಅನ್ವಯವಾಗುವ ಮರುಪಾವತಿಯನ್ನು ಮಾಡಲಾಗುತ್ತದೆ.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RefundRulesAndClaimsKn;
